import React, { useState } from 'react';
import { Input, InputVariants } from '../../UI';
import { Button, ButtonVariants } from '../../UI';
import { useInput } from '../../hooks/useInput';

interface CommentFormProps {
  onSubmit: (content: string) => void;
}

export const CommentForm: React.FC<CommentFormProps> = (props) => {

  const { onSubmit } = props;
  const [showButtons, setShowButtons] = useState<boolean>(false);

  const {
    inputValue: commentValue,
    hasError: commentHasError,
    onInputChange: onCommentChange,
    onInputBlur: onCommentBlur,
    resetInput: resetCommentValue,
  } = useInput((value) => value.length > 0);

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    onSubmit(commentValue);
    resetCommentValue();
    setShowButtons(false);
  };

  const handleCancle = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowButtons(false);
  };

  return (
    <div>
      <div>
        <Input
          variant={InputVariants.BORDER_BOTTOM}
          name={'add-comment'}
          // id={'comment-input'}
          value={commentValue}
          hasError={commentHasError}
          errorMessage={'Field can not be empty'}
          onChange={onCommentChange}
          onBlur={onCommentBlur}
          onFocus={() => setShowButtons(true)}
          required={true}
        />
        {
          showButtons
            ? <div className='flex justify-end'>

              <Button onClick={handleCancle} variant={ButtonVariants.ROUNDED_DARK}>
                Cancle
              </Button>
              <Button disabled={commentValue.length <= 0} onClick={handleSubmit} variant={ButtonVariants.ROUNDED_BLUE}>
                Comment
              </Button>
            </div>
            : null
        }
      </div>
    </div>
  );
};
